import { Service } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { ServicesServicePriceCalculationMutationProps } from '@services/requests/servicesService/servicesServicesService/interface';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * InitialCalculationResultProcessor формирует начальные значения расчетов для каждой услуги в каждом варианте
 */
export class InitialCalculationResultProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const servicesByDir: { directoryID: string; services: Service[] }[] = [];
    const calculationResult: { [T in string]: ServicesServicePriceCalculationMutationProps[] } = {};

    Object.entries(additionalServiceState.VariantServices).forEach(([dirId, services]) => {
      servicesByDir.push({ directoryID: dirId, services });
    });

    servicesByDir.map((r) => {
      calculationResult[r.directoryID] = [];
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantsCalculationResult: calculationResult,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
